const cancelOrderStatusSelector = (orderId: string) => (
    state: sage.state.IRedux
): sage.status.CancelStatus => {
    return state.balance.cancelOrderStatus[orderId] || "none";
};

export default cancelOrderStatusSelector;
